export default "__VITE_ASSET__BnK9M7vD__"